function FeatureList({ items }) {
  return (
    <div className="row mx-5 g-4 px-3 py-2 row-cols-xxl-5 justify-content-center d-none d-xxl-flex">
      {items.map((item, i) => (
        <div key={i} className="col d-flex align-items-start">
          <div>
            <h3 className={`fs-2 text-body-emphasis ${item.color}`}>
              {item.title}
            </h3>
            <p>
              {item.description}
            </p>
            <a href={item.href} className={`icon-link ${item.color}`}>
              Részletek
              <i className={`bi bi-chevron-right ${item.color}`}/>
            </a>
          </div>
        </div>
      ))}
    </div>
  );
}

export default FeatureList;
